import React, { useState } from "react";
import { Users, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

// dipendenti: [{id, nome, cognome, ...}]; selezionati: array di id; etichetta(d) opzionale
export function SelettoreDipendenti({ dipendenti, selezionati, onChange, etichetta, testid = "selettore-dipendenti", className = "" }) {
  const [open, setOpen] = useState(false);
  const toggle = (id) => onChange(selezionati.includes(id) ? selezionati.filter((x) => x !== id) : [...selezionati, id]);
  const nomi = dipendenti.filter((d) => selezionati.includes(d.id)).map((d) => `${d.nome} ${d.cognome}`.trim());
  const label =
    nomi.length === 0 ? "Seleziona dipendenti" : nomi.length === 1 ? nomi[0] : nomi.length <= 2 ? nomi.join(", ") : `${nomi.length} dipendenti selezionati`;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" className={`w-full justify-between bg-white font-normal ${nomi.length === 0 ? "text-slate-400" : ""} ${className}`} data-testid={`${testid}-trigger`}>
          <span className="truncate flex items-center gap-2"><Users className="h-4 w-4 shrink-0 text-slate-400" />{label}</span>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[340px] p-0" align="start" data-testid={`${testid}-popover`}>
        <div className="flex items-center justify-between px-3 py-2 border-b text-xs text-slate-500">
          <span>{selezionati.length} selezionat{selezionati.length === 1 ? "o" : "i"}</span>
          <div className="flex gap-2">
            <button type="button" className="hover:text-primary" onClick={() => onChange(dipendenti.map((d) => d.id))} data-testid={`${testid}-tutti`}>Tutti</button>
            <button type="button" className="hover:text-primary" onClick={() => onChange([])} data-testid={`${testid}-nessuno`}>Nessuno</button>
          </div>
        </div>
        <div className="max-h-72 overflow-y-auto py-1">
          {dipendenti.map((d) => (
            <label key={d.id} className="flex items-center gap-3 px-3 py-2 hover:bg-orange-50 cursor-pointer text-sm" data-testid={`${testid}-item-${d.id}`}>
              <Checkbox checked={selezionati.includes(d.id)} onCheckedChange={() => toggle(d.id)} />
              <span className="flex-1 truncate">{etichetta ? etichetta(d) : `${d.nome} ${d.cognome}`}</span>
            </label>
          ))}
        </div>
        <div className="border-t px-3 py-2 flex justify-end">
          <Button type="button" size="sm" className="h-7 text-xs" onClick={() => setOpen(false)} data-testid={`${testid}-conferma`}>
            <Check className="h-3.5 w-3.5 mr-1" /> Conferma
          </Button>
        </div>
      </PopoverContent>
    </Popover>
  );
}
